<template>
  <div v-if="display">
    <modal-layout-top :title="title" />

    <div class="content slider-modal">
      <div class="field is-horizontal">
        <div class="field-body">
          <div class="field is-grouped">
            <div class="field-label">
              <label class="label">År</label>
            </div>
            <p class="control is-expanded">
              <input class="input" type="number" v-model="priceList.year" />
            </p>
          </div>
        </div>
      </div>
      <button class="button" @click="copyFromLatest()" v-if="priceList.priceListDefaultId == 0">Kopiera från senaste</button>

      <hr>

      <h4>Taxa</h4>
      <div class="field is-horizontal" v-for="item in priceList.lines.filter(x => x.productType === 'Rate')" :key="item.productId">
        <div class="field-body">
          <div class="field is-grouped">
            <div class="field-label">
              <label class="label">{{ item.productName }}</label>
            </div>
            <p class="control is-expanded">
              <input type="number" class="input" v-model="item.price">
            </p>
          </div>
        </div>
      </div>

      <!--
      <h4>Taxa</h4>
      <div class="field" v-for="item in priceList.lines.filter(x => x.productType === 'Rate')" :key="item.productId">
        <div class="field-body">
          <label class="label">{{ item.productName }}</label>
          <p class="control is-expanded">
            <input type="number" class="input is-small" v-model="item.price">
          </p>
        </div>
      </div>
      -->

      <h4>Hyra</h4>
      <div class="field is-horizontal" v-for="item in priceList.lines.filter(x => x.productType === 'Rent')" :key="item.productId">
        <div class="field-body">
          <div class="field is-grouped">
            <div class="field-label">
              <label class="label">{{ item.productName }}</label>
            </div>
            <p class="control is-expanded">
              <input type="number" class="input" v-model="item.price">
            </p>
          </div>
        </div>
      </div>

      <!--
      <h4>Hyra</h4>
      <div class="field" v-for="item in priceList.lines.filter(x => x.productType === 'Rent')" :key="item.productId">
        <div class="field-body">
          <label class="label">{{ item.productName }}</label>
          <p class="control">
            <input type="number" class="input is-small" v-model="item.price">
          </p>
        </div>
      </div>
      -->

      <input type="text" class="input" placeholder="Kommentar" v-model="priceList.comment">
      <modal-layout-buttons :store-name="'priceListDefault'" />
    </div>
  </div>
</template>

<script>

import { mapActions } from 'vuex'
import ModalLayoutTop from '@/components/modals/ModalLayoutTop'
import ModalLayoutButtons from '@/components/modals/ModalLayoutButtons'

export default {
  name: 'price-list-default-modal',
  data () {
    return {
      priceList: { },
      isUpdate: false,
      display: false
    }
  },
  components: {
    ModalLayoutTop,
    ModalLayoutButtons
  },
  props: {
    id: {
      type: Number,
      required: false
    }
  },
  computed: {
    title () {
      if (!this.isUpdate) {
        return 'Skapa ny prislista'
      } else {
        return 'Ändra prislista ' + this.priceList.year
      }
    }
  },
  methods: {
    ...mapActions('priceListDefault', ['update', 'create', 'getById', 'getLatest']),
    closePanel () {
      this.$emit('closePanel')
    },
    save () {
      const priceMissing = this.priceList.lines.filter(x => !x.price)

      if (priceMissing && priceMissing.length > 0) {
        this.$toast('Fyll i samtliga priser (' + priceMissing.length + ' priser saknas)', 'error')
        return
      }

      if (this.priceList.priceListDefaultId) {
        this.update(this.priceList).then(() => {
          this.closePanel()
        }).catch(() => {
          this.$toast('Felaktig data', 'error')
        })
      } else {
        this.create(this.priceList).then(() => {
          this.closePanel()
        })
      }
    },
    copyFromLatest () {
      console.log('comp start')
      this.getLatest().then(x => {
        console.log('comp end')
        x.priceListDefaultId = 0
        this.priceList = Object.assign({}, x)
      })
    }
  },
  created () {
    this.$on('emitSave', () => {
      this.save()
    })
    this.getById(this.id).then((priceList) => {
      this.priceList = priceList
      this.display = true
    })
    this.isUpdate = this.id !== 0
  }
}
</script>

<style soped>
  .field-body {
    margin-top: 1rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/modals/PriceListDefaultModal.vue